import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../../../components/AppAnimate";
import AppCard from "../../../../../components/layouts/components/AppCard";
import ManageContactInfo from "./ManageContactInfo";
import CodeEditor from "../../../template/components/CodeEditor";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import LiveHelpRoundedIcon from '@material-ui/icons/LiveHelpRounded';


class ContactInformationPage extends React.Component {
    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.contactInformation}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.contactInformation}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.contactInformation}/>
                            }>
                            <ManageContactInfo/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.footer_certificates}
                        >
                            <Alert style={{marginBottom:30}} severity="info" icon={<LiveHelpRoundedIcon fontSize="inherit" />} >
                                <AlertTitle><strong>{Translate.footerCertificationTitle}</strong></AlertTitle>
                                {Translate.footerCertificationText}
                            </Alert>
                            <CodeEditor type="footer_certificates"/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.map_script}
                        >
                            <Alert style={{marginBottom:30}} severity="info" icon={<LiveHelpRoundedIcon fontSize="inherit" />} >
                                <AlertTitle><strong>{Translate.mapScriptTitle}</strong></AlertTitle>
                                {Translate.mapScriptText}
                            </Alert>
                            <CodeEditor type="map_script"/>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withSnackbar(withStyles(Styles)(ContactInformationPage));
